import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PlayerDto } from "../../../models";

@Component({
    selector: 'playmaker-modal',
    templateUrl: './playmaker.modal.html',
    styleUrls: ['./playmaker.modal.scss'],
})
export class PlayMakerModal {
    @Input() players: PlayerDto[];
    
    @Input() selectedPlayer: PlayerDto;

    constructor(public activeModal: NgbActiveModal) {
    }

    getPlayerName(player: PlayerDto) {
        let result = (player.name ? player.name[0] + ". " : "" )+ player.surname;

        return result.trim();
    }

    selectPlayer(player: PlayerDto) {
        this.activeModal.close(player);
    }
}